import * as _ from 'lodash';

export const deepCopy = <T>(source: T): T => {
    return _.cloneDeep(source);
};



// WEBPACK FOOTER //
// ./src/main/webapp/app/shared/utils/clone-utils.ts